import React, { useState } from 'react';
import { Button, Card, Dropdown, Form, Modal } from 'react-bootstrap';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import FalconCardHeader from 'components/common/FalconCardHeader';
// import { recentLeadsTableData } from 'data/dashboard/crm';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import PropTypes from 'prop-types';
import SubtleBadge from 'components/common/SubtleBadge';
import Avatar from './Avatar';
import IconItem from 'components/common/icon/IconItem';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { postNurseNotification } from 'nursd-dashboard/api/nurseNotification';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import {
  sendNotification,
  sendCustomEmail
} from 'nursd-dashboard/api/webNotification';
import CardDropdown from 'components/common/CardDropdown';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import Flex from 'components/common/Flex';

const RecentLeads = ({ data }) => {
  let tableData = data;
  const { authToken } = useAuth();

  const [show, setShow] = useState(false);
  const [type, setType] = useState('');
  const [obj, setObj] = useState(undefined);
  const [content, setContent] = useState('');

  const handleClose = () => {
    setShow(false);
    setObj(undefined);
    setType('');
    setContent('');
  };
  const handleShow = e => {
    setShow(true);
    setObj(e);
  };

  const columns = [
    {
      accessorKey: 'nurse',
      header: 'Name',
      meta: {
        headerProps: {
          className: 'px-3 text-900'
        },
        cellProps: {
          className: 'px-3'
        }
      },
      cell: ({ row: { original } }) => {
        const { nurse } = original;
        return (
          <Link to={paths.nursd_profile(nurse?.id, 'profile')}>
            <Flex alignItems="center">
              {nurse?.profileImage ? (
                <Avatar src={nurse?.profileImage} size="xl" className="me-2" />
              ) : (
                <Avatar size="xl" name={nurse?.name} className="me-2" />
              )}
              <div className="flex-1">
                <h5 className="mb-0 fs-10">{nurse?.name}</h5>
              </div>
            </Flex>
          </Link>
        );
      }
    },
    {
      accessorKey: 'name',
      header: 'Document Name',
      meta: {
        headerProps: {
          className: 'py-0 ps-3 text-900'
        },
        cellProps: {
          className: 'ps-3'
        }
      },
      cell: ({ row: { original } }) => {
        const { name } = original;
        return (
          <div
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          >
            <h6 className="mb-0 ps-2">{name}</h6>
          </div>
        );
      }
    },
    {
      accessorKey: 'type',
      header: 'Document Type',
      meta: {
        headerProps: {
          className: 'py-0 ps-0 text-900'
        },
        cellProps: {
          className: 'ps-0'
        }
      },
      cell: ({ row: { original } }) => {
        const { type } = original;
        return (
          <div
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          >
            <h6 className="mb-0 ps-2">
              {type === 'certification'
                ? 'Certification'
                : type === 'document'
                ? 'Document'
                : type === 'clinicalLicense'
                ? 'Clinical License'
                : ''}
            </h6>
          </div>
        );
      }
    },
    {
      accessorKey: 'valid',
      header: 'Valid Until',
      meta: {
        headerProps: {
          className: 'py-0 ps-0 text-900'
        },
        cellProps: {
          className: 'ps-0'
        }
      },
      cell: ({ row: { original } }) => {
        const { valid } = original;
        return (
          <div
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          >
            <h6 className="mb-0 ps-2">{valid}</h6>
          </div>
        );
      }
    },
    {
      accessorKey: 'expirationStatus',
      header: 'Status',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { expirationStatus } = original;
        return (
          <SubtleBadge
            pill
            bg={expirationStatus ? 'danger' : 'success'}
            className="me-2"
          >
            {expirationStatus ? 'Expired' : 'Valid'}
          </SubtleBadge>
        );
      }
    },
    {
      accessorKey: 'Action',
      header: 'Action/Alert',
      meta: {
        headerProps: {
          className: 'text-900'
        }
      },
      enableSorting: false,
      cell: ({ row: { original } }) => {
        const { nurse } = original;
        return (
          <div
            style={{
              display: 'flex'
            }}
          >
            {/* <a href={`mailto:${nurse?.email}`}> */}
            <IconItem
              tag="button"
              icon={'envelope-open'}
              size="sm"
              className="btn rounded-3"
              onClick={() => {
                handleShow(nurse);
                setType('Email');
              }}
            />
            {/* </a> */}
            <IconItem
              tag="button"
              icon={'bell'}
              size="sm"
              className="btn rounded-3 mx-2"
              onClick={() => {
                handleShow(nurse);
                setType('Alert');
              }}
            />
            <CardDropdown>
              <div className="py-2">
                <Dropdown.Item
                  as={Link}
                  to={paths.nursd_profile(nurse?.id, 'documents')}
                >
                  Upload
                </Dropdown.Item>
              </div>
            </CardDropdown>
          </div>
        );
      }
    }
  ];

  const table = useAdvanceTable({
    data: tableData,
    columns,
    // selection: true,
    sortable: true,
    pagination: true,
    perPage: 10,
    selectionColumnWidth: 28,
    selectionHeaderClassname: 'py-0'
  });

  const sendEmail = async () => {
    if (obj?.mobileId) {
      sendNotification(authToken, {
        expoPushToken: obj?.mobileId,
        title: `Email Alert`,
        body: `Check your email.`,
        data: { screen: 'NotificationScreen' }
      });
    }
    await postNurseNotification(
      authToken,
      obj?.id,
      '',
      'Email Alert',
      'Check your email.',
      'NotificationScreen',
      {},
      false,
      false,
      'green',
      ''
    );
    sendCustomEmail(authToken, {
      email: obj?.email,
      name: obj?.name,
      subject: 'Email Alert',
      content: '',
      body: content
    });
    handleClose();
  };

  const sendAlert = async () => {
    if (obj?.mobileId) {
      sendNotification(authToken, {
        expoPushToken: obj?.mobileId,
        title: `Alert`,
        body: content,
        data: { screen: 'NotificationScreen' }
      });
    }
    await postNurseNotification(
      authToken,
      obj?.id,
      '',
      'Alert',
      content,
      'NotificationScreen',
      {},
      false,
      false,
      'green',
      ''
    );
    handleClose();
  };

  const handleChange = ({ target }) => {
    setContent(target.value);
  };

  return (
    <>
      <AdvanceTableProvider {...table}>
        <Card>
          <FalconCardHeader
            title={'Documents List'}
            titleTag="h4"
            className="py-3 text-primary"
          />
          <Card.Body className="p-0">
            <AdvanceTable
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap hover-actions-trigger btn-reveal-trigger hover-bg-100"
              tableProps={{
                className: 'fs-10 mb-0 overflow-hidden'
              }}
            />
          </Card.Body>
          <Card.Footer className="px-2 py-3">
            <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
          </Card.Footer>
        </Card>
      </AdvanceTableProvider>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            {type === 'Email' ? 'Email Alert' : 'Mobile Alert'}
          </Modal.Title>
          <FalconCloseButton onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-2" controlId="content">
            <Form.Label className="fs-9">Content</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="content"
              onChange={handleChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => (type === 'Email' ? sendEmail() : sendAlert())}
          >
            Send {type}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

RecentLeads.propTypes = {
  data: PropTypes.any,
  tableRemainderDetails: PropTypes.any
};

export default RecentLeads;
